"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Observable_1 = require("rxjs/Observable");
var dialog_config_helper_1 = require("../../../../../shared/utils/dialog-config-helper");
var material_1 = require("@angular/material");
var overview_config_dialog_component_1 = require("./overview-config-dialog/overview-config-dialog.component");
var operators_1 = require("rxjs/operators");
var confirm_dialog_component_1 = require("../../../../../shared/dialogs/confirm/confirm-dialog.component");
var base_portfolio_config_dialog_component_1 = require("../base-portfolio-config/base-portfolio-config-dialog/base-portfolio-config-dialog.component");
var root_entity_config_model_1 = require("../../../common/model/root-entity-config.model");
var overview_config_item_model_1 = require("../../../common/model/overview-config-item.model");
var overview_card_type_1 = require("../../../common/model/overview-card-type");
var base_portfolio_config_model_1 = require("../../../common/model/base-portfolio-config.model");
var overview_helper_service_1 = require("../../../common/service/overview-helper.service");
/**
 * Overview cards' and their portfolio's configurations.
 */
var OverviewConfigComponent = /** @class */ (function () {
    function OverviewConfigComponent(dialog, overviewHelperService) {
        this.dialog = dialog;
        this.overviewHelperService = overviewHelperService;
    }
    OverviewConfigComponent.prototype.ngOnInit = function () {
        if (this.config.overviewConfigModel && this.config.overviewConfigModel.overviewItemsConfig) {
            this.overviewHelperService.sortOverviewCards(this.config.overviewConfigModel.overviewItemsConfig);
        }
        this.config$ = Observable_1.Observable.of(this.config);
    };
    OverviewConfigComponent.prototype.openCardDialog = function (config, itemConfig) {
        var _this = this;
        var dialogConfig = dialog_config_helper_1.DialogConfigHelper.getDialogBasicConfig({ width: '1000px' });
        var processingConfigItem = itemConfig ? itemConfig.clone() : new overview_config_item_model_1.OverviewConfigItemModel();
        dialogConfig.data = {
            itemConfig: processingConfigItem,
            rootCategory: this.category
        };
        this.dialog.open(overview_config_dialog_component_1.OverviewConfigDialogComponent, dialogConfig).afterClosed()
            .pipe(operators_1.take(1))
            .subscribe(function (returnedItemConfig) {
            // when creating new card
            if (returnedItemConfig && !itemConfig) {
                if (!config.overviewItemsConfig.length) {
                    returnedItemConfig.id = 1;
                    if (returnedItemConfig.cardType.id !== overview_card_type_1.OverviewCardType.MAIN_CARD) {
                        returnedItemConfig.orderId = 1;
                    }
                }
                else {
                    returnedItemConfig.id = Math.max.apply(Math, config.overviewItemsConfig.map(function (item) { return item.id; })) + 1;
                    if (returnedItemConfig.cardType.id !== overview_card_type_1.OverviewCardType.MAIN_CARD) {
                        returnedItemConfig.orderId = Math.max.apply(Math, config.overviewItemsConfig.map(function (item) { return item.orderId || 0; })) + 1;
                    }
                }
                config.overviewItemsConfig.push(returnedItemConfig);
            }
            else if (returnedItemConfig && itemConfig) {
                config.overviewItemsConfig[config.overviewItemsConfig.findIndex(function (item) { return item.id === returnedItemConfig.id; })] =
                    returnedItemConfig;
            }
            _this.overviewHelperService.sortOverviewCards(config.overviewItemsConfig);
        });
    };
    OverviewConfigComponent.prototype.openPortfolioDialog = function (config) {
        var dialogConfig = dialog_config_helper_1.DialogConfigHelper.getDialogBasicConfig({ width: '820px' });
        var processingConfigItem = config.portfolioConfig ? config.clone().portfolioConfig : new base_portfolio_config_model_1.BasePortfolioConfigModel();
        dialogConfig.data = {
            itemConfig: processingConfigItem,
            cardCategory: config.itemCategoryName,
            mainCategory: this.category
        };
        this.dialog.open(base_portfolio_config_dialog_component_1.BasePortfolioConfigDialogComponent, dialogConfig).afterClosed()
            .pipe(operators_1.take(1))
            .subscribe(function (returnedItemConfig) {
            if (returnedItemConfig) {
                config.portfolioConfig = returnedItemConfig;
            }
        });
    };
    OverviewConfigComponent.prototype.delete = function (config, itemConfig) {
        var dialogConfig = dialog_config_helper_1.DialogConfigHelper.getConfirmationDialogConfig('ejustice_confirm_removing_card', 'ejustice_are_you_sure_removing_card');
        this.dialog.open(confirm_dialog_component_1.ConfirmDialogComponent, dialogConfig)
            .afterClosed()
            .pipe(operators_1.take(1))
            .subscribe(function (confirmed) {
            if (confirmed) {
                config.overviewItemsConfig.splice(config.overviewItemsConfig.findIndex(function (item) { return itemConfig.id === item.id; }), 1);
            }
        });
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", root_entity_config_model_1.RootEntityConfigModel)
    ], OverviewConfigComponent.prototype, "config", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], OverviewConfigComponent.prototype, "category", void 0);
    OverviewConfigComponent = __decorate([
        core_1.Component({
            selector: "ejustice-overview-config",
            styles: [require('./overview-config.component.css')],
            template: require('./overview-config.component.html'),
        }),
        __metadata("design:paramtypes", [material_1.MatDialog,
            overview_helper_service_1.OverviewHelperService])
    ], OverviewConfigComponent);
    return OverviewConfigComponent;
}());
exports.OverviewConfigComponent = OverviewConfigComponent;
//# sourceMappingURL=overview-config.component.js.map